import functionImplementation from "./functionImplementation";
import Store from "../store/index";
import locale from "../locale/locale";
import getLocalizedFunctionList from "../function/getLocalizedFunctionList";
import functionListDescriptor from "./functionListDescriptor";
//{"0":"数学","1":"统计","2":"查找","3":"Luckysheet内置","4":"数据挖掘","5":"数据源","6":"日期","7":"过滤器","8":"财务","9":"工程计算","10":"逻辑","11":"运算符","12":"文本","13":"转换工具","14":"数组"}

/**
 * @description 函数列表 - 20260403 新增自定义函数功能
 * @param { Array<{ name: string, implement: Function, description: Object }> } customFunctions 自定义函数列表
 * 该函数实现的具体流程：
 *  1. 通过 getLocalizedFunctionList 获取本地化后的函数列表
 *  2. 通过 `f.n` 获取函数实现 （借助 functionImplementation ）
 */
const functionlist = function (customFunctions) {
    let localeFunctionList = locale().functionlist;

    // 1. 合并自定义函数和内置函数列表
    if (customFunctions && customFunctions.length > 0) {
        for (const customFun of customFunctions) {
            // 这里是需要将 desc 添加到 localeFunctionList 中
            localeFunctionList[customFun.name] = customFun.description;
            // 这里需要添加描述
            functionListDescriptor.push(customFun.description);
            // 这里要添加描述
            functionImplementation[customFun.name] = customFun.implementation;
        }
    }

    // internationalization,get function list
    let functionListOrigin = [...getLocalizedFunctionList(localeFunctionList, functionListDescriptor)];

    // add new property f
    for (let i = 0; i < functionListOrigin.length; i++) {
        let func = functionListOrigin[i];
        func.f = functionImplementation[func.n];
    }

    // if (customFunctions) {
    //     functionListOrigin.push(...customFunctions);
    // }

    Store.functionlist = functionListOrigin;

    // get n property
    const luckysheet_function = {};

    for (let i = 0; i < functionListOrigin.length; i++) {
        let func = functionListOrigin[i];
        luckysheet_function[func.n] = func;
    }

    window.luckysheet_function = luckysheet_function; // Mount window for eval() calculation formula

    Store.luckysheet_function = luckysheet_function;
};

export default functionlist;
